import React, { useState } from 'react';
import {
  ModalOverlay,
  ModalContainer,
  Header,
  CloseButton,
  BackButton,
  Content,
  UserIcon,
  HeaderTitle,
  ModalTitle,
  ModalSubtitle,
  FeedbackSection,
  FeedbackTitle,
  CategoryTitle,
  OptionsContainer,
  FeedbackButton,
  CommentsSection,
  CommentsTitle,
  CommentsContainer,
  TextArea,
  CharacterCount,
  Footer,
  FooterButton,
  ValidationMessageError,
  ValidationMessageInfo
} from './styles';
import CheckGreenIcon from '../../assets/images/check_green.svg';
import ExclamationSvg from '../../assets/images/exclamation.svg';
import ArrowIcon from '../../assets/images/arrow.svg';

const FeedbackModal = ({ isOpen, onClose, onBack, onNext, onCloseWithoutApi, type = 'agreement' }) => {
  const [selectedPositive, setSelectedPositive] = useState([]);
  const [selectedNegative, setSelectedNegative] = useState([]);
  const [selectedDivergences, setSelectedDivergences] = useState([]);
  const [commentsText, setCommentsText] = useState('');
  const [showOthersField, setShowOthersField] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  React.useEffect(() => {
    if (!isOpen) {
      setSelectedPositive([]);
      setSelectedNegative([]);
      setSelectedDivergences([]);
      setCommentsText('');
      setShowOthersField(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const config = {
    agreement: {
      icon: CheckGreenIcon,
      iconAlt: 'Confirmação',
      title: 'Obrigado por confirmar',
      subtitle: 'Selecione os pontos que melhor descrevem como foi a visita. Se precisar, utilize a opção \'Outros\' para acrescentar um comentário.',
      sectionTitle: 'Conte-nos como foi',
      hasCategories: true,
      showComments: true
    },
    disagreement: {
      icon: ExclamationSvg,
      iconAlt: 'Exclamação',
      title: 'Encontrou alguma divergência?',
      subtitle: 'Selecione os pontos que não correspondem. Se precisar, utilize a opção \'Outros\' para acrescentar um comentário.',
      sectionTitle: 'Seleção de divergências',
      hasCategories: false,
      showComments: false
    }
  };

  const currentConfig = config[type];

  const handlePositiveSelect = (option) => {
    setSelectedPositive(prev =>
      prev.includes(option)
        ? prev.filter(item => item !== option)
        : [...prev, option]
    );
  };

  const handleNegativeSelect = (option) => {
    setSelectedNegative(prev =>
      prev.includes(option)
        ? prev.filter(item => item !== option)
        : [...prev, option]
    );
  };

  const handleDivergenceSelect = (option) => {
    if (option === 'Outros') {
      setShowOthersField(!showOthersField);
      if (showOthersField) {
        setSelectedDivergences(prev => prev.filter(item => item !== 'Outros'));
      } else {
          setSelectedDivergences(prev =>
          prev.includes('Outros') ? prev : [...prev, 'Outros']
        );
      }
    } else {
      setSelectedDivergences(prev =>
        prev.includes(option)
          ? prev.filter(item => item !== option)
          : [...prev, option]
      );
    }
  };

  const handleOthersClick = () => {
    if (type === 'agreement') {
      setShowOthersField(prev => {
        const newValue = !prev;

        setSelectedPositive(currentSelected => {
          if (newValue) {
            return currentSelected.includes('Outros') ? currentSelected : [...currentSelected, 'Outros'];
          } else {
            return currentSelected.filter(item => item !== 'Outros');
          }
        });

        return newValue;
      });
    } else {
      setShowOthersField(prev => !prev);
    }
  };

  const handleBack = () => {
    setSelectedPositive([]);
    setSelectedNegative([]);
    setSelectedDivergences([]);
    setCommentsText('');
    setShowOthersField(false);
    if (typeof onBack === 'function') {
      onBack();
    }
  };

  const positiveOptions = [
    'Atendimento cordial',
    'Explicações claras',
    'Sugestões úteis',
    'Bom conhecimento técnico',
    'Pontualidade'
  ];

  const negativeOptions = [
    'Dados em branco',
    'Não cumpriu o combinado',
    'Visita muito rápida',
    'Atraso',
    'Falta de preparo técnico',
    'Foco insuficiente nas necessidades'
  ];

  const divergenceOptions = [
    'Plano de ação incorreto',
    'Produto/serviço diferente',
    'Prazo errado',
    'Quantidade divergente',
    'Dados desatualizados',
    'Informações incompletas',
    'Outros'
  ];

    const getTotalSelected = () => {
    if (type === 'agreement') {
      return selectedPositive.length + selectedNegative.length;
    }
    return selectedDivergences.length;
  };

  const totalSelected = getTotalSelected();

  return (
    <ModalOverlay>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          <BackButton onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleBack();
          }}>
            <img src={ArrowIcon} alt="Voltar" />
            <span>Voltar</span>
          </BackButton>
          <CloseButton onClick={() => {
            if (typeof onCloseWithoutApi === 'function') onCloseWithoutApi();
            else if (typeof onClose === 'function') onClose();
            else if (typeof onBack === 'function') onBack();
          }}>×</CloseButton>
        </Header>

        <Content>
          <UserIcon>
            <img src={currentConfig.icon} alt={currentConfig.iconAlt} />
          </UserIcon>

          <HeaderTitle>
            <ModalTitle>{currentConfig.title}</ModalTitle>
            <ModalSubtitle>
              {currentConfig.subtitle}
            </ModalSubtitle>
          </HeaderTitle>

          <FeedbackSection>
            <FeedbackTitle>
              {currentConfig.sectionTitle} <span style={{ color: '#CBCBCB' }}>(mínimo 2 opções)</span>
            </FeedbackTitle>

            {currentConfig.hasCategories ? (
              <>
                <div>
                  <CategoryTitle positive>Pontos positivos</CategoryTitle>
                  <OptionsContainer>
                    {positiveOptions.map((option, index) => (
                      <FeedbackButton
                        key={index}
                        selected={selectedPositive.includes(option)}
                        positive
                        onClick={() => handlePositiveSelect(option)}
                      >
                        {option}
                      </FeedbackButton>
                    ))}
                  </OptionsContainer>
                </div>

                <div>
                  <CategoryTitle negative>Pontos negativos</CategoryTitle>
                  <OptionsContainer>
                    {negativeOptions.map((option, index) => (
                      <FeedbackButton
                        key={index}
                        selected={selectedNegative.includes(option)}
                        negative
                        onClick={() => handleNegativeSelect(option)}
                      >
                        {option}
                      </FeedbackButton>
                    ))}
                  </OptionsContainer>
                </div>

                <OptionsContainer style={{ marginBottom: '0' }}>
                  <FeedbackButton
                    others
                    selected={selectedPositive.includes('Outros')}
                    onClick={handleOthersClick}
                  >
                    Outros
                  </FeedbackButton>
                </OptionsContainer>
              </>
            ) : (
                <>
                <OptionsContainer>
                  {divergenceOptions.map((option, index) => (
                    <FeedbackButton
                      key={index}
                      selected={selectedDivergences.includes(option)}
                      onClick={() => handleDivergenceSelect(option)}
                      others={option === 'Outros'}
                    >
                      {option}
                    </FeedbackButton>
                  ))}
                </OptionsContainer>

                {showOthersField && type === 'disagreement' && (
                  <CommentsSection inline>
                    <CommentsTitle>Descreva a divergência encontrada</CommentsTitle>
                    <CommentsContainer>
                      <TextArea
                        value={commentsText}
                        onChange={(e) => setCommentsText(e.target.value)}
                        placeholder="Conte-nos o que aconteceu"
                        maxLength={250}
                      />
                      <CharacterCount>{commentsText.length}/250</CharacterCount>
                    </CommentsContainer>
                    {commentsText.length > 0 && commentsText.length < 10 && (
                      <ValidationMessageError>
                        Mínimo de 10 caracteres para enviar ({commentsText.length}/10)
                      </ValidationMessageError>
                    )}

                    {commentsText.length === 0 && (
                      <ValidationMessageInfo>
                        Mínimo de 10 caracteres para enviar
                      </ValidationMessageInfo>
                    )}
                  </CommentsSection>
                )}
              </>
            )}
          </FeedbackSection>

          {showOthersField && currentConfig.showComments && (
            <CommentsSection>
              <CommentsTitle>Especifique</CommentsTitle>
              <CommentsContainer>
                <TextArea
                  value={commentsText}
                  onChange={(e) => setCommentsText(e.target.value)}
                  placeholder="Digite aqui o que mais gostaria de destacar"
                  maxLength={250}
                />
                <CharacterCount>{commentsText.length}/250</CharacterCount>
              </CommentsContainer>
              {commentsText.length > 0 && commentsText.length < 10 && (
                <ValidationMessageError>
                  Mínimo de 10 caracteres para enviar ({commentsText.length}/10)
                </ValidationMessageError>
              )}

              {commentsText.length === 0 && (
                <ValidationMessageInfo>
                  Mínimo de 10 caracteres para enviar
                </ValidationMessageInfo>
              )}
            </CommentsSection>
          )}
        </Content>

        <Footer>
          <FooterButton
            primary
            disabled={
              totalSelected < 2 ||
              isSubmitting ||
              (showOthersField && (!commentsText || commentsText.trim().length < 10))
            }
            onClick={async () => {
              if (isSubmitting) return;

              const selectedItemsArray = type === 'agreement'
                ? [...selectedPositive, ...selectedNegative].filter(i => i && i !== 'Outros')
                : selectedDivergences.filter(i => i && i !== 'Outros');

              const selectedItemsStr = (selectedItemsArray && selectedItemsArray.length > 0)
                ? selectedItemsArray.join(', ')
                : '';

              const comment = showOthersField && commentsText && commentsText.trim()
                ? commentsText.trim()
                : undefined;

              const payload = {
                user_id: localStorage.getItem('userId') || null,
                selected_items: selectedItemsStr,
              };

              if (typeof comment !== 'undefined') payload.comment = comment;

              setIsSubmitting(true);
              try {
                if (typeof onNext === 'function') {
                  await onNext(payload);
                }
              } catch (e) {
                console.warn('FeedbackModal onNext error', e);
              } finally {
                setIsSubmitting(false);
              }
            }}
          >
            {isSubmitting ? 'Enviando...' : 'Próximo passo'}
          </FooterButton>
        </Footer>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default FeedbackModal;
